import { Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { VehicleFrequency } from '../../../models/entities/vehicle-frequency';

@Component({
  selector: 'laveo-select-vehicle-frequency',
  templateUrl: './select-vehicle-frequency.component.html',
  styleUrls: ['./select-vehicle-frequency.component.scss']
})
export class SelectVehicleFrequencyComponent {
  @Input() control: AbstractControl | null;
  @Input() typeSize: 'default' | 'small' | 'large' = 'large';

  public get vehicleFrequencyValues(): VehicleFrequency[] {
    return Object.values(VehicleFrequency);
  }

  public get formControl(): UntypedFormControl {
    return this.control as UntypedFormControl;
  }
}
